module.exports = __webpack_public_path__ + "media/images/sports-f7bb29dead262d2a2fa65f0d9cf73fbe.jpg";